// Only exists for client side. Should not be needed post Clerk organization migration

import {
  numberOfCustomModelsFirst,
  numberOfCustomModelsFree,
  numberOfCustomModelsSecond,
  numberOfCustomModelsThird,
} from "@/constants/payment";
import { User } from "@/types/types";
import { getSubscriptionPlan } from "@/utils/subscriptionLevels/getSubscriptionPlan";

export const getNumberOfCustomModelsAllowedClientTemp = (
  stripeSubscriptionId: User["stripeSubscriptionId"]
): number => {
  const subscriptionPlan = getSubscriptionPlan(stripeSubscriptionId);

  if (subscriptionPlan === "first") {
    return numberOfCustomModelsFirst;
  } else if (subscriptionPlan === "second") {
    return numberOfCustomModelsSecond;
  } else if (subscriptionPlan === "third") {
    return numberOfCustomModelsThird;
  }

  // Free plan
  return numberOfCustomModelsFree;
};
